import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { isHelixOnlyHub } from 'utils/helix';
import { useUpdateMyUserSettings } from 'actions/userSettings';
import PageSection from 'components/PageSection';
import UserPageHeader from 'components/UserPageHeader';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Card from 'components/Card';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Landmark from 'components/Landmark';
import { usersQueryKeys } from 'actions/users';
import useCustomContactLink from 'hooks/useCustomContactLink';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ContactLink(_ref) {
  var children = _ref.children;
  var contactLink = useCustomContactLink();
  if (contactLink.url) {
    return /*#__PURE__*/_jsx(TextLink, {
      href: contactLink.url,
      target: "_blank",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(TextLink, {
    as: "button",
    onClick: contactLink.openModal,
    children: children
  });
}
var HubLink = function HubLink(_ref2) {
  var domain = _ref2.domain,
    children = _ref2.children;
  if (!domain) {
    return /*#__PURE__*/_jsx(Text, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(TextLink, {
    as: "a",
    href: domain,
    target: "_blank",
    children: children
  });
};
function HelixNotAvailablePage(_ref3) {
  var isCurrentUser = _ref3.isCurrentUser,
    userId = _ref3.userId,
    user = _ref3.user,
    helixHubDomain = _ref3.helixHubDomain,
    helixHubName = _ref3.helixHubName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useUpdateMyUserSetti = useUpdateMyUserSettings(),
    updateUserSettings = _useUpdateMyUserSetti.updateUserSettings;
  return /*#__PURE__*/_jsx(PageSection, {
    flush: true,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "l",
      maxWidth: 860,
      mb: "m",
      mt: isHelixOnlyHub ? 'm' : '0',
      children: [user && /*#__PURE__*/_jsx(UserPageHeader, _objectSpread({}, user)), /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t(isCurrentUser ? helixHubDomain ? 'skills_helix_not_linked_title' : 'error_forbidden' : 'skills_admin_helix_not_linked_title')
      }), /*#__PURE__*/_jsx(Card, {
        p: "m",
        children: isCurrentUser ? helixHubDomain ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Stack, {
            spacing: "s",
            children: [/*#__PURE__*/_jsxs(Trans, {
              t: t,
              i18nKey: "skills_helix_not_linked_text_1",
              values: {
                helixHubName: helixHubName,
                helixHubDomain: helixHubDomain
              },
              children: ["Helix can only be linked to one hub that you are a member of, and at the moment you have it linked to", ' ', /*#__PURE__*/_jsx("strong", {
                children: helixHubName
              }), " (", /*#__PURE__*/_jsx(HubLink, {
                domain: helixHubDomain,
                children: helixHubDomain
              }), ")."]
            }), /*#__PURE__*/_jsx(Text, {
              children: t('skills_helix_not_linked_text_2')
            }), /*#__PURE__*/_jsx(Text, {
              children: t('skills_helix_not_linked_text_3')
            })]
          }), /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            justifyContent: "center",
            mt: "m",
            children: /*#__PURE__*/_jsx(Button, {
              variant: "primary",
              onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 1;
                      return updateUserSettings({
                        is_helix_hub: true
                      });
                    case 1:
                      _context.next = 2;
                      return queryClient.invalidateQueries({
                        queryKey: usersQueryKeys.helixAccess(userId)
                      });
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })),
              children: t('actions_use_this_hub_for_helix')
            })
          })]
        }) : /*#__PURE__*/_jsx(Landmark, {
          children: /*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsxs(Trans, {
              t: t,
              i18nKey: "error_content_access_denied",
              children: ["You do not have permission to view this content. If you think this is an error, please", /*#__PURE__*/_jsx(ContactLink, {
                children: "let us know"
              }), "."]
            })
          })
        }) : /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('skills_admin_helix_not_linked_text_1')
          }), /*#__PURE__*/_jsx(Text, {
            children: t('skills_admin_helix_not_linked_text_2')
          })]
        })
      })]
    })
  });
}
export default HelixNotAvailablePage;